<template>
  <div class="wrap">
    <img src="../assets/img/article-banner.png" alt="" class="article-banner">
    <ul class="article-nav">
      <li>工作情感</li>
      <li>动漫文化</li>
      <li>漫画小说</li>
      <li>综合</li>
      <li>游戏</li>
    </ul>
    <img src="../assets/img/article-ad.png" alt="" class="article-ad">
    <div class="article-content">
      <div class="header-title cleafix">
        <img src="http://imgs.aixifan.com/cms/2017_03_10/1489114940717.gif?imageView2/1/w/100/h/100" alt="">
        <h4>文章推荐</h4>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">24</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">日本关西中南部8天8夜深度游(高野山、熊野三山、大阪、京都)...</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: madaomomo</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">4274</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">161</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">我说我画的是AC娘你们信吗!</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 我是猫er</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">2.9万</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">41</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">夏日的人像祭之甜系少女</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 俺是粽子</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">1.1万</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">23</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">简单的记录下日本简单的旅游吧</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 小受变小攻</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">4348</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">45</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">【料理9课】姐姐的晚餐</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 灰来灰去喵</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">5638</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">17</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">【H事】178看片</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: aliannng</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">1.2万</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">38</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">银魂642 | 戴着眼镜的家伙 变成鬼也会戴着眼镜</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 冰块儿w</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">9968</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">57</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">2017魔都CCG一日游 (没啥小姐姐)</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 亵渎灬依然</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">1.9万</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">40</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">闲不下来的周末——百奇花生碎饼干(伪)</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: joe你要吗</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">9631</span>
          </div>
        </div>
      </div>
      <div class="article-sub">
        <div class="comment fl">
          <span class="comment-num">118</span>
          <p>评论</p>
        </div>
        <div class="sub-info">
          <h4 class="sub-title">骑行,青春在路上,出发了,up已经获得当事人授权,他人不得转载</h4>
          <div class="sub-user clearfix">
            <span class="user-name fl">UP主: 心情有点冷</span>
            <i class="fa fa-eye"></i>
            <span class="sub-num fr">2.3万</span>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
      data() {
          return {

          }
      }
  }
</script>

<style lang="less" scoped>
  @import '../assets/css/article.less';
</style>



// WEBPACK FOOTER //
// article.vue?4d33f41c